import * as klaro from "klaro/dist/klaro-no-css"; // JS sense CSS
import "klaro/dist/klaro.css"; // fulla d’estils
import { klaroConfig } from "../../klaro-config";

function renderOnce() {
  // torna a dibuixar el banner però no el mostra automàticament
  klaro.render(klaroConfig, { show: false });
}

export default {
  install(app) {
    // contenidor i arrencada inicial
    const host = document.createElement("div");
    host.id = "cookie-modal";
    document.body.appendChild(host);
    klaro.setup(klaroConfig);

    /* ==== API global per canviar d’idioma ==== */
    function setKlaroLang(newLang) {
      if (!newLang || klaroConfig.lang === newLang) return;
      klaroConfig.lang = newLang; // 1) actualitza config
      document.documentElement.lang = newLang; // 2) opcional però recomanat
      renderOnce(); // 3) re-renderitza
    }

    // exposem la funció perquè qualsevol component la pugui cridar
    app.config.globalProperties.$setKlaroLang = setKlaroLang;
  },
};
